export const LOGIN_FORM = 'login_form'
export const MAINTENANCE_CARD = 'maintenance_card'
export const TITLE_BAR_CLOSE_BUTTON = 'title_bar_close_button'
export const TITLE_BAR_SHARE_BUTTON = 'title_bar_share_button'
export const TITLE_BAR_MOBILE_CLOSE_BUTTON = 'title_bar_mobile_close_button'
export const TITLE_BAR_MOBILE_SHARE_BUTTON = 'title_bar_mobile_share_button'
export const SIGN_UP_INSTEAD_LINK = 'sign_up_instead_link'
export const OAUTH_PARTNER_CONTENT_TITLE = 'oauth_partner_content_title'
